/***
 * PC_SRG_01 importing the api functions and salaryRevisionForm Component
 */
import { useState, useEffect, useRef } from 'react';
import React from 'react';
import moment from 'moment-timezone';
import { getEmployeeSalaryRevisionInfo, postEmployeeSalaryRevisionInfo } from '../service/DirectorAPI';
import { SalaryRevision } from './SalaryRevisionForm';
import Loader from '../StaticComponent/Loader';
import fileUpload from '../components/SalaryRevisionForm';
import { Upload, uploadBackend } from '../utils/Upload';



import { encryptStorage } from '../constant';
import { getS3 } from '../utils/Download.js';

/**
 * PC_TD_03 create a SalaryRevisionGrid(props) function and it return the HTML
 *
 */
export function SalaryRevisionGrid(props) {
    /***
     * PC_SRG_02
     * Declaring the state variables and objects
     */
    let SalaryRevisionGridarray = [];
    const [salaryGridData, setsalaryGridData] = useState(SalaryRevisionGridarray);
    const [flag, setFlag] = useState(false)
    const [columnOrder, setColumnOrder] = useState('DESC');
    const [columnName, setColumnName] = useState('created_at');
    const [sorthide, setsorthide] = useState('');
    const [pagemode, setpagemode] = useState('false');
    const [EmpId, setEmpId] = useState('');
    const [countPerPage, setCoutPerPage] = useState(10);
    const [dataLength, setdataLength] = useState();
    const [offerId, setOfferId] = useState();
    const [deleteofferId, setDeleteOfferId] = useState('');
    const [isSalaryFormClick, setIsSalaryFormcliclk] = useState(false);
    const [Emp_name, setEmpname] = useState('');
    const [Emp_domain, setEmpdomain] = useState('');
    const [isLoading, setIsLoading] = React.useState(true);

    const [deletePopUp, setDeletePopUp] = useState(true);
    let loginEmpId = encryptStorage.getItem('employeeId');
    let role = encryptStorage.getItem('role');
    //PC_SR_1 -> signedOffer is declared
    const [signedOffer, setSignedOffer] = useState('');
    //PC_SR_2 -> signedOfferError is declared
    const [signedOfferError, setSignedOfferError] = useState([]);
    //PC_SR_3 -> crossImg is declared
    let crossImg = useRef();
    let attachment = useRef();

    /***
     * PC_SRG_03
     *  useEffect method call the loadSalaryRevision function to get the data from BD
     */
    useEffect(() => {
        loadsalaryRevision();
        setEmpId(props.empId);
        setEmpname(props.emp_name);
        setEmpdomain(props.emp_domain);
    }, [props, countPerPage, columnName, columnOrder]);

    /***
     * PC_SRG_03.1,PC_SRG_04
     * this function call the getEmployeeSalaryRevisionInfo
     * this function get the data from BD
     */

    const loadsalaryRevision = async () => {
        try {
            let empdata = {
                emp_id: props.empId,
                sortOrder: columnOrder,
                sortColumn: columnName,
                PageSize: countPerPage,
            };
            setIsLoading(false);
            let data = await getEmployeeSalaryRevisionInfo(empdata);
            if (data.data.Success === true) {
                setIsLoading(true);
            }
            setsalaryGridData(data.data.ResponseData[0]);
          
          
let array =signedOfferError
array=new Array(data.data.ResponseData[0]).fill("");

            const anotherArray = data.data.ResponseData[0]
            const lengthOfAnotherArray = anotherArray.length;

            array.length = lengthOfAnotherArray; // Set the length of emptyArray

            // Fill emptyArray with empty strings
            array.fill("");



            // Array filled with false values

            setSignedOfferError(array)
            //setSignedOffer(data.data.ResponseData[0].signed_offer_url);
            setdataLength(data.data.ResponseData[0].length);
        } catch (e) { }
    };

    //PC_SR_14 -> the function signedOfferData is defined
    function signedOfferData(e) {
        try {

            //PC_SR_15 -> file is declared
            let file = e.target.value;
            //PC_SR_16 -> condition is checked
            const typeArr = ['pdf'];
            let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
            if (file != null && e.target.files[0].size <= 1000000 && type == true) {
                // let val=salaryGridData
                // val[i].signed_offer_url=attachment.current.files[0]
                // setsalaryGridData(val);
                const updatedSalaryGridData = [...salaryGridData];
                // Create a copy of the original array
 
                updatedSalaryGridData[e.target.name]["signed_offer_url"]= e.target.files[0] // Update the 'signed_offer_url' property
             
               
                setsalaryGridData(updatedSalaryGridData);
                //setSignedOffer(attachment.current.files[0]);
            }
            //PC_SR_17 -> else the condition fails
            else {
                if (e.target.files[0].size >= 1000000) {
                    let val = signedOfferError
                    val[e.target.name] = "File size should be less than 1MB"
                    setSignedOfferError(val);
                    setFlag(!flag)
                }
                if (type == false) {
                    let val = signedOfferError
                    val[e.target.name] = "The uploaded file should be in PDF format"
                    setSignedOfferError(val);
                    setFlag(!flag)
                }
            }
        } catch (e) {
            throw e;
        }
    }
    //PC_SR_21 -> updateSignedOffer() is defined
    async function updateSignedOffer(i) {
        //PC_SR_22 -> signedUploadFile is declared

        let dirName = `${EmpId}-Salary_Signed_${salaryGridData.length + 1}`;
        let signedUploadFile = await uploadBackend(salaryGridData[i]["signed_offer_url"], salaryGridData[i]["signed_offer_url"].name, dirName);

        let updatedata = {
            request_type: 'OfferUpdate',
            emp_id: EmpId,
            login_emp_id: loginEmpId,
            role: role,
            id: salaryGridData[i].id,
 
            signed_offer_url: signedUploadFile,
        };
 
        let signedOfferResponse = await postEmployeeSalaryRevisionInfo(updatedata);
        if (signedOfferResponse.data.status == 200) {
            loadsalaryRevision();
        }

        // PC_SR_23 -> signedOfferResponse is declared
        // let signedOfferResponse = postEmployeeSalaryRevisionInfo(signedOffer);
        // //PC_SR_24 -> the function is defined in Api.js
        // //PC_SR_40 -> signedOfferResponse is checked for 200
        // if (signedOfferResponse.status == 200) {
        //     loadsalaryRevision();
        // }
    }

    /***
     * PC_SRG_10 PC_SR_5-10
     * this function map and return the value
     */

    const salaryRevisionGridBodyData = () => {
        try {
            if (salaryGridData.length == 0) {
                return (
                    <tr>
                        <td colspan="10" className="accord-content1">
                            <div className="row justify-content-center">
                                <img
                                    src="/Images/nodatafound.png"
                                    alt="nodatafound"
                                    className="nofeedbackimg-sty"
                                    style={{ height: '500px', width: '750px' }}
                                />
                                <h2 className="tt-bold font-15 text-center margin-negative">No Records Found</h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                return salaryGridData.map((obj, index) => {
                    let signedOfferIndex=index
                    let errorValue=signedOfferError[index]
                    let ActiveFrom =  moment.utc(obj.active_from).format('MMM DD, YYYY') 
    
                    let NextVisitDate = obj.next_visit_date 
                    ? moment.utc(obj.next_visit_date).format('MMM DD, YYYY') : '-';
                

                    var tipCount;
                    var commentsBind;
                    if (obj.apprisal_comments.length > 15) {
                        commentsBind = obj.apprisal_comments.substring(0, 15);
                        commentsBind = commentsBind + '...';
                        tipCount = 1;
                    } else {
                        commentsBind = obj.apprisal_comments;
                        tipCount = 0;
                    }
                    let signed_offer_s3_upload=false;
if(obj?.signed_offer_url!==undefined&&obj?.signed_offer_url!==""&&obj?.signed_offer_url!==null){
    if(typeof(obj?.signed_offer_url)=="string"){
        if(obj?.signed_offer_url?.includes('https:')){
            signed_offer_s3_upload=true
        }
    }
   
}
           

                    
 
                    return (
                        <tr className="hive-table-data">
                            <td className="text-end" id={index}>{obj.current_ctc} CTC</td>
                            <td className="text-end">{obj.revised_ctc} CTC</td>
                            <td>{ActiveFrom}</td>
                            {(role == 'Hr Manager' || role == 'Hr') && (props.empId !== loginEmpId)?<td>{NextVisitDate}</td>:<></>}
                            {/* <td>{obj.apprisal_comments} </td>  obj.offer_attach_url */}
                            <td>
                                <a
                                    className={tipCount == 0 ? 'tooltip-color tooltipCursor' : 'tooltip-color'}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title={tipCount == 1 ? obj.apprisal_comments : ''}
                                >
                                    {commentsBind}
                                </a>
                            </td>
                            <td>
                                <a style={{cursor:"pointer"}} onClick={async () => {

window.open(await getS3(obj.offer_attach_url), "_blank");


}} target="_blank" className="text-decoration-none profile-offer-letter">
                                    <img
                                        className="me-2"
                                        src="/Images/profile-salary-attachment.svg"
                                        title="Attachment"
                                        alt="Attachment Icon"
                                    />
                                    Attachment.pdf
                                </a>
                            </td>

                            {(role == 'Hr Manager' || role == 'Hr' || role == 'Manager') &&
                                props.empId !== loginEmpId &&
                                props.EmployeeStatus != 'Inactive' ? (
                                <td>
                                    <a style={{cursor:"pointer"}} onClick={async () => 
                !obj.signed_offer_url&&!signed_offer_s3_upload ? obj.signed_offer_url
                    : window.open(await getS3(obj.signed_offer_url), "_blank") 
            }
 
                                    target="_blank" className="text-decoration-none profile-offer-letter">
                                        {!obj.signed_offer_url ? '-' : 'Signed_Attachment.pdf'}
                                    </a>
                                </td>
                            ) : (
                                <></>
                            )}

                            {props.empId == loginEmpId && props.EmployeeStatus != 'Inactive' ? (
                                <td>

                                    {!obj.signed_offer_url ? (
                                        <>
                                            <div className="custom-upload-btn-wrapper">
                                                <label htmlFor={`salary-Revision-${index}`} className="goalform-custom-file-upload">
                                                    <img className="me-2" src="Images/profile-upload-icon.svg" alt="Upload Icon" />
                                                    Upload
                                                </label>

                                                <input
                                                    id={`salary-Revision-${index}`}
                                                    type="file"
                                                    className="profile-file-upload"
                                                    name={index}

                                                    onChange={(e) => {

                                                        signedOfferData(e)
                                                      }}
                                                     
                                                    
                                                    />
                                                    <label className="hive-form-mandatory" />
                                                </div>
                                                <label className="hive-form-mandatory">{signedOfferError[index]}</label>
                                            </>
                                        )  :  obj.signed_offer_url ? (
                                            <>
                                            <a style={{cursor:"pointer"}} onClick={async () => 
                !obj.signed_offer_url&&!signed_offer_s3_upload ? obj.signed_offer_url
                    : window.open(await getS3(obj.signed_offer_url), "_blank") 
            }

                                    target="_blank" className="text-decoration-none profile-offer-letter">  <span>Signed_Attachment.pdf</span></a>
                                              
                                                {!signed_offer_s3_upload? <><img
                                                        src={'/Images/tick-task.svg'}
                                                        className="ms-2"
                                                        onClick={() => {
                                                            
                                                            updateSignedOffer(index);
                                                        } } /><img
                                                            src={'/Images/Cross-task.svg'}
                                                            className="ms-2"
                                                            onClick={() => {
                                                                //debugger
                                                                crossImg = null;
let val=salaryGridData
                                                                val[index].signed_offer_url=null
                                                                setsalaryGridData(val)
                                                                setFlag(!flag)
                                                                // setSignedOffer(undefined);
                                                            } } /></>:<></>}
                                            </>
                                        ) : null}
                                 
                                </td>
                            ) : (
                                <></>
                            )}

                            {(role == 'Hr Manager' || role == 'Hr') &&
                                obj.is_first_revision == 0 &&
                                props.EmployeeStatus != 'Inactive' &&
                                props.empId !== loginEmpId ? (
                                <td className="text-center">
                                    <a href="#" className="text-decoration-none mx-2">
                                        <img
                                            src="/Images/profile-edit-icon-enable.svg"
                                            title="Edit"
                                            alt="Edit Icon"
                                            data-bs-toggle="modal"
                                            data-bs-target="#SalaryRevisionPopup"
                                            id={obj.id}
                                            onClick={(e) => offerEditClicked(e)}
                                        />
                                    </a>
                                    <a href="#" className="text-decoration-none mx-2">
                                        <img
                                            src="/Images/profile-delete-icon-enable.svg"
                                            title="Delete"
                                            alt="Delete Icon"
                                            id={obj.id}
                                            onClick={(e) => deleteClicked(e)}
                                        />
                                    </a>
                                </td>
                            ) : null}

                            {(role == 'Hr Manager' || role == 'Hr') &&
                                (obj.is_first_revision == 1 || props.EmployeeStatus == 'Inactive') &&
                                props.empId !== loginEmpId ? (
                                <td className="text-center">
                                    <img
                                        className="text-decoration-none mx-2"
                                        src="/Images/edit-disabled.svg"
                                        title="Edit"
                                        alt="Edit Icon"
                                    />
                                    <img
                                        className="text-decoration-none mx-2"
                                        src="/Images/delete-disabled.svg"
                                        title="Delete"
                                        alt="Delete Icon"
                                    />
                                </td>
                            ) : null}
                        </tr>
                    );
                });
            }
        } catch (e) {
            throw e
        }
    };

    /***
     * PC_SRG_22
     * this function set the column name and sort order into the object
     * and call the loadsalaryRevision function.
     */
    const sortClicked = (e) => {
        debugger
        try {
            let sortID = e.target.id;
            let sortval = sortID.split('@');
            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
            //loadsalaryRevision();
        } catch (error) { }
    };

    /***
     * PC_SRG_22
     * this function increase the page size bu clicking load more button
     */
    const handleLoadMore = () => {
        try {
            setCoutPerPage(countPerPage + 10);
            //loadGridPage();
        } catch (e) { }
    };
    /***
     * PC_SRG_31
     * this function send the page mode and empId to the salary revision form component
     * through props
     */
    const newOfferClicked = () => {
        setIsSalaryFormcliclk(true);
        setEmpId(props.empId);
        setpagemode('');
        setOfferId('');
    };

    /***
     * PC_SRG_31
     * this function send the page mode and empId to the salary revision form component
     * through props
     */

    const offerEditClicked = (e) => {
        setIsSalaryFormcliclk(true);
        setEmpId(props.empId);
        setpagemode('Edit');
        setOfferId(e.target.id);
    };

    /***
     * PC_SRG_13
     * this function delete the salary revision by clicking the delete icon
     * and this functin call the postEmployeeSalaryRevisionInfo api function
     */

    const deleteClicked = (e) => {
        setDeletePopUp(false);
        setDeleteOfferId(e.target.id);
    };

    /**
     *
     * PC_SRG_13.1 deleteOffer() function delete the offer record
     */
    const deleteOffer = async (offerId) => {
        try {
            let deletesalaryrev = {
                request_type: 'Delete',
                id: offerId,
                emp_id: EmpId,
                login_emp_id: loginEmpId,
                role: role,
            };

            let responsedata = await postEmployeeSalaryRevisionInfo(deletesalaryrev);
            if (responsedata.data.status == 200) {
                loadsalaryRevision();
                setDeletePopUp(true);
            }
        } catch (e) { }
    };

    /**
     * PC_SRG_13.2 cancelClickedDelete() function set the deletePopUp is true to hide the popup
     */
    const cancelClickedDelete = () => {
        setDeletePopUp(true);
    };

    /**
     * PC_SRG_13.3 yesClicked() function invock the deleteOffer()
     */
    const yesClicked = () => {
        deleteOffer(deleteofferId);
    };

    return (
        <div>
            <div className="col-md-12 my-3 d-flex align-items-center ">
                <h2 className="hive-title">Salary Revision</h2>
                <Loader isLoading={isLoading} />

                {(role == 'Hr Manager' || role == 'Hr') && loginEmpId != EmpId && props.EmployeeStatus != 'Inactive' ? (
                    <div className="ms-auto d-flex">
                        <button
                            className="btn hive-btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#SalaryRevisionPopup"
                            onClick={() => newOfferClicked()}
                        >
                            <img className="me-2" src="/Images/profile-plus-action.svg" alt="Plus Icon" />
                            New Offer Letter
                        </button>
                    </div>
                ) : null}
            </div>
            <div className="col-md-12">
                <div className="table-responsive">
                    <table className="table bg-white hive-grid table-borderless profile-regular-font">
                        <thead>
                            <tr>
                                <th className="hive-table-head text-end bold-text font-14">
                                    Current CTC
                                    <span className="ps-2">
                                        <img
                                            src="/Images/Sort-up.svg"
                                            className="hive-table-sort"
                                            id="current_ctc@ASC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'current_ctc@ASC' ? true : false}
                                        />
                                        <img
                                            src="/Images/sort-icon.svg"
                                            className="hive-table-sort"
                                            id="current_ctc@DESC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'current_ctc@ASC' ? false : true}
                                        />
                                    </span>
                                </th>
                                <th className="hive-table-head text-end bold-text font-14">
                                    Revised CTC
                                    <span className="ps-2">
                                        <img
                                            src="/Images/Sort-up.svg"
                                            className="hive-table-sort"
                                            id="revised_ctc@ASC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'revised_ctc@ASC' ? true : false}
                                        />
                                        <img
                                            src="/Images/sort-icon.svg"
                                            className="hive-table-sort"
                                            id="revised_ctc@DESC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'revised_ctc@ASC' ? false : true}
                                        />
                                    </span>
                                </th>
                                <th className="hive-table-head bold-text font-14">
                                    Active From
                                    <span className="ps-2">
                                        <img
                                            src="/Images/Sort-up.svg"
                                            className="hive-table-sort"
                                            id="active_from@ASC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'active_from@ASC' ? true : false}
                                        />
                                        <img
                                            src="/Images/sort-icon.svg"
                                            className="hive-table-sort"
                                            id="active_from@DESC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'active_from@ASC' ? false : true}
                                        />
                                    </span>
                                </th>
                                {(role == 'Hr Manager' || role == 'Hr')&&(props.empId !== loginEmpId)?
                                <th className="hive-table-head text-end bold-text font-14">
                                    Next Revision Month
                                    <span className="ps-2">
                                        <img
                                            src="/Images/Sort-up.svg"
                                            className="hive-table-sort"
                                            id="next_visit_date@ASC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'next_visit_date@ASC' ? true : false}
                                        />
                                        <img
                                            src="/Images/sort-icon.svg"
                                            className="hive-table-sort"
                                            id="next_visit_date@DESC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'next_visit_date@ASC' ? false : true}
                                        />
                                    </span>
                                </th>:<></>}
                                <th className="hive-table-head bold-text font-14">
                                    Appraisal Comments
                                    <span className="ps-2">
                                        <img
                                            src="/Images/Sort-up.svg"
                                            className="hive-table-sort"
                                            id="apprisal_comments@ASC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'apprisal_comments@ASC' ? true : false}
                                        />
                                        <img
                                            src="/Images/sort-icon.svg"
                                            className="hive-table-sort"
                                            id="apprisal_comments@DESC"
                                            onClick={(e) => sortClicked(e)}
                                            hidden={sorthide == 'apprisal_comments@ASC' ? false : true}
                                        />
                                    </span>
                                </th>
                                <th className="hive-table-head bold-text font-14">Offer Letter</th>
                                <th className="hive-table-head bold-text font-14">Signed Offer Letter</th>
                                {(role == 'Hr Manager' || role == 'Hr') && props.empId !== loginEmpId ? (
                                    <th className="hive-table-head text-center bold-text font-14">Action</th>
                                ) : null}
                            </tr>
                        </thead>
                        <tbody>{salaryRevisionGridBodyData()}</tbody>
                    </table>
                </div>
                {dataLength >= countPerPage ? (
                    <div className="text-center">
                        <button className="btn btn show-more-btn" onClick={() => handleLoadMore()}>
                            Show More
                        </button>
                    </div>
                ) : null}

                <div className="Failure-PopUp pop-bg" hidden={deletePopUp == true ? true : false}>
                    <div className="modal-dialog goal-popup modal-dialog-centered">
                        <div className="modal-content px-5">
                            <div className="modal-body text-center px-5 py-4">
                                <p className="bold-text font-18 text-blue my-5">Are you sure do you want to delete the Salary Revision? </p>

                                <div className="text-center d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="btn hive-btn-secondary bold-text font-14 me-3"
                                        onClick={() => cancelClickedDelete()}
                                    >
                                        No
                                    </button>

                                    <button className="btn hive-btn-primary bold-text font-14" type="submit" onClick={() => yesClicked()}>
                                        Yes Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* PC_SRG_33 salaryRevision function is called from salaryRevisionForm.jsx */}
            <SalaryRevision
                empId={EmpId}
                emp_name={Emp_name}
                emp_domain={Emp_domain}
                Mode={pagemode}
                Id={offerId}
                isSalaryFormClicked={isSalaryFormClick}
                setIsSalaryFormcliclk={() => setIsSalaryFormcliclk()}
                loadsalaryRevision={() => loadsalaryRevision()}
                count={salaryGridData.length}
            />
        </div>
    );
}

export default SalaryRevisionGrid;